import React, { useEffect,useState } from 'react';
import './style/ApplicationForm.css';

function ApplicationForm() {
    const [passportData, setPassportData] = useState('');
    const [availableServices, setAvailableServices] = useState([]);
    const [selectedServiceIds, setSelectedServiceIds] = useState([]);
    const [carInfo, setCarInfo] = useState(null);

    useEffect(() => {
        fetch('http://localhost:8082/api/services', {
            headers: {
                'User-Agent': 'insomnia/11.2.0',
            },
        })
            .then((res) => res.json())
            .then((data) => {
                const activeServices = data.filter(service => service.active);
                setAvailableServices(activeServices);
            })
            .catch((err) => {
                console.error('Ошибка при загрузке услуг:', err);
            });
    }, []);

    const handleServiceChange = (serviceId) => {
        setSelectedServiceIds((prev) =>
            prev.includes(serviceId)
                ? prev.filter((id) => id !== serviceId)
                : [...prev, serviceId]
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const phone = localStorage.getItem('phoneNumber');
        if (!phone) {
            alert('Номер телефона не найден в localStorage');
            return;
        }
        if (!passportData) {
            alert('Пожалуйста, введите паспортные данные');
            return;
        }
        try {
            for (const serviceId of selectedServiceIds) {
                await fetch('http://localhost:8082/api/service-history/createorder', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ phone, serviceId ,passportData}),
                });
            }

            alert('Заявка успешно отправлена!');
            setSelectedServiceIds([]);
            window.location.href = '/';
        } catch (error) {
            console.error('Ошибка при отправке заявки:', error);
            alert('Ошибка при отправке заявки');
        }
    };


    const handleGetCarInfo = async () => {
        const carNumber = localStorage.getItem('carNumber');
        if (!carNumber) {
            alert('Авто номер не найден в localStorage');
            return;
        }

        try {
            const response = await fetch('http://localhost:8081/api/users/getByCarNumber', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'carNumber': carNumber,
                },
            });

            if (!response.ok) {
                throw new Error('Ошибка при получении данных об авто');
            }

            const data = await response.json();

            setCarInfo({
                carNumber: data.carNumber,
                car_model: data.car_model,
                god_car: data.god_car,
                carTechPassport: data.carTechPassport,
            });
        } catch (error) {
            console.error('Ошибка:', error);
            alert('Не удалось получить данные об авто');
        }
    };




    return (
        <div className="application-wrapper">
            <div className="application-card">
                <h2>Продолжение заявки</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Паспортные данные:</label>
                        <input
                            type="text"
                            value={passportData}
                            onChange={(e) => setPassportData(e.target.value)}
                            placeholder="AB1234567"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Выбор услуг:</label>
                        <div className="checkbox-list">
                            {availableServices.map((service) => (
                                <label key={service.id} className="checkbox-item">
                                    <input
                                        type="checkbox"
                                        checked={selectedServiceIds.includes(service.id)}
                                        onChange={() => handleServiceChange(service.id)}
                                    />
                                    <span>{service.name}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="buttons">
                        <button type="button" className="btn-outline" onClick={handleGetCarInfo}>
                            Получить данные об авто
                        </button>
                        <button type="submit" className="btn-primary">
                            Отправить заявку
                        </button>
                    </div>
                </form>

                {carInfo && (
                    <div className="car-info">
                        <h3>Информация об авто</h3>
                        <p><strong>Номер авто:</strong> {carInfo.carNumber}</p>
                        <p><strong>Модель:</strong> {carInfo.car_model}</p>
                        <p><strong>Год:</strong> {carInfo.god_car}</p>
                        <p><strong>Техпаспорт:</strong> {carInfo.carTechPassport}</p>
                    </div>
                )}

            </div>
        </div>
    );
}

export default ApplicationForm;
